import { useEffect } from 'react';

import useLanguage from './useLanguage';
import useAuth from './useAuth';
import useGQLQuery from './useGQLQuery';
import { useStore as profileStore } from '../../contexts/profile';

const useProfile = () => {
	const { data: { navigation }, dispatch } = profileStore();
	const { isLanguageLoaded, t } = useLanguage();
	const { userData } = useAuth();

	useEffect(() => {
		if (navigation === null && isLanguageLoaded) {
			dispatch({
				type: 'SET_NAVIGATION',
				payload: {
					name: 'settings',
					list: [
						{ href: '/profil', text: t('labelAccount') },
						userData.oauth_id ? null : { href: '/profil/uporabnik', text: t('labelAccountProfile') },
						{ href: '/profil/obvestila-nastavitve', text: t('labelAccountNotifications') },
						{ href: '/profil/placila', text: t('labelAccountPayments') }
					]
				}
			});
		}
	}, [isLanguageLoaded]);

	// Query, profile counters
	const { result, error, refetch: getSubmenutCnt } = useGQLQuery(null, 'profile>submenu-cnt', {}, { enabled: false });

	return { navigation, getSubmenutCnt, result, error };
};

export default useProfile;
